import { createSlice } from "@reduxjs/toolkit";
import { clearErrors, returnErrors } from "./ErrorReducer";
import axios from "axios";
import { toast } from "react-toastify";

let initialState = {
	data: null,
	search: "",
	status: "",
	mainSearch: null,
	isFound: null,
  day:null,
  month:null
};

export const leaderboardSlice = createSlice({
	name: "leaderboard",
	initialState,
	reducers: {
		getSearchLeaderboard: (state, { payload }) => {
			state.mainSearch =
				payload?.search === state?.search
					? payload?.data || payload
					: state?.mainSearch;
			state.search_paginate =
				payload?.search === state?.search
					? payload?.paginate || null
					: state?.search_paginate;
			state.isFound = true;
		},
		getSearch: (state, { payload }) => {
			state.search = payload?.search || payload;
		},
		resetLeaderboardSearch: state => {
			state.search = "";
			state.mainSearch = [];
			state.search_paginate = null;
			state.isFound = false;
		},
		getLeaderboard: (state, { payload }) => {
			state.data = payload?.data || payload;
			state.paginate = payload?.paginate;
		},
		getLeaderboardDay: (state, { payload }) => {
			state.day = payload?.data || payload;
			state.paginate_day = payload?.paginate;
		},
		getLeaderboardMonth: (state, { payload }) => {
			state.month = payload?.data || payload;
			state.paginate_month = payload?.paginate;
		},
		leaderboardFail: state => {
			state.status = "";
			state.isFound = null;
		},
		logoutLeaderboard: state => {
			state.status = "";
			state.isFound = null;
			state.data = null;
			state.day = null;
			state.month = null;
			state.mainSearch = null;
			state.paginate = null;
		},
	},
});
export const {
	leaderboardFail,
	getLeaderboard,
	getSearchLeaderboard,
	getSearch,
	resetLeaderboardSearch,
	logoutLeaderboard,
  getLeaderboardDay,getLeaderboardMonth
} = leaderboardSlice.actions;

export const manageLeaderboard = (type, data) => async dispatch => {
	dispatch(clearErrors());
	try {
		let res;

		if (type === "get") {
			res = await axios.get(
				`/api/v1/exam/leaderboard?type=${data?.type || "all"}${
					data?.limit ? `&limit=${data?.limit}` : ""
				}`
			);
			dispatch(data?.type === 'month' ? getLeaderboardMonth(res?.data) : data?.type === 'day' ? getLeaderboardDay(res?.data): getLeaderboard(res.data));
		}
		if (type !== "get") {
			toast.success(res?.data?.message);
			setTimeout(() => {
				dispatch(leaderboardFail());
			}, 1000);
		}
	} catch (err) {
		if (err) console.log({ error: err.response?.data, err });
		if (err?.response?.status === 429) toast.error(err?.response?.data);
		dispatch(leaderboardFail());
		if (type && type !== "get") {
			let error = err.response?.data?.error;
			if (error && error?.length > 1) {
				dispatch(returnErrors({ error, status: err?.response?.status }));
			} else {
				toast.error(err?.response?.data?.message || err?.message);
			}
		}
	}
};
